import { SupportedLocales } from '@/models/localization.model';

export function translatableValueToLocaleMap(value: unknown, locales: SupportedLocales[]): Record<string, string> {
  if (typeof value === 'string') {
    const primary = locales[0];
    return locales.reduce<Record<string, string>>((acc, l) => {
      acc[l] = primary !== undefined && l === primary ? value : '';
      return acc;
    }, {});
  }
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    const o = value as Record<string, unknown>;
    return locales.reduce<Record<string, string>>((acc, l) => {
      const v = o[l];
      acc[l] = typeof v === 'string' ? v : '';
      return acc;
    }, {});
  }
  return locales.reduce<Record<string, string>>((acc, l) => {
    acc[l] = '';
    return acc;
  }, {});
}

export function mergeGalleryAltsFromHeader(
  items: unknown[],
  headerVal: unknown,
  locales: SupportedLocales[],
): unknown[] {
  const headerMap = translatableValueToLocaleMap(headerVal, locales);
  return items.map((row) => {
    if (!row || typeof row !== 'object' || Array.isArray(row)) return row;
    const r = { ...(row as Record<string, unknown>) };
    const alt = r.alt;
    const nextAlt: Record<string, string> = {};
    locales.forEach((l) => {
      let cur = '';
      if (alt && typeof alt === 'object' && !Array.isArray(alt)) {
        const a = (alt as Record<string, unknown>)[l];
        cur = typeof a === 'string' ? a : '';
      }
      nextAlt[l] = cur.trim() === '' ? headerMap[l] ?? '' : cur;
    });
    r.alt = nextAlt;
    return r;
  });
}
